import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useLanguage } from './LanguageContext';
import { fetchPublishedOverlay } from '../lib/wiki/draftsApi';

const WikiOverlayContext = createContext({ overlay: { bySlug: {}, newPages: [] }, reload: () => {} });

export function WikiOverlayProvider({ children }) {
  const { language } = useLanguage();
  const [overlay, setOverlay] = useState({ bySlug: {}, newPages: [] });

  const reload = useCallback(async () => {
    const data = await fetchPublishedOverlay(language);
    setOverlay(data);
  }, [language]);

  useEffect(() => { reload(); }, [reload]);

  return (
    <WikiOverlayContext.Provider value={{ overlay, reload }}>
      {children}
    </WikiOverlayContext.Provider>
  );
}

export function useWikiOverlay() {
  return useContext(WikiOverlayContext);
}
